import React, { useState, useEffect } from 'react';
import { Github, Youtube, Mail, ChevronRight, Terminal, Briefcase, Zap, ArrowUpRight, BookOpen, Globe, Menu, X } from 'lucide-react';

// X (Twitter) Logo Icon
const XIcon = ({ size = 20 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 22.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.008 5.961h-1.91z" />
  </svg>
);

// 다국어 번역 데이터
const translations = {
  en: {
    nav_about: "About", nav_projects: "Projects", nav_insights: "Insights", nav_contact: "Get in touch",
    hero_badge: "Vibe Coder & CSO",
    hero_hello: "Hello, I am ", hero_desc1: ".",
    hero_desc2: "Breaking the boundaries between technology and business to create new value as a CSO.",
    hero_desc3: "Building businesses with strategic insights on top of strong fundamentals as a {years}-year developer.",
    github_btn: "GitHub Archive", youtube_btn: "YouTube Channel", x_btn: "X (Twitter)",
    proj_title: "Strategic Projects", proj_desc: "Core projects creating business impact.",
    proj_alpha_desc: "Next-generation platform providing innovative communication experiences. Designed an intuitive interface and stable real-time data processing architecture.",
    proj_beta_desc: "O2O life-care matching solution solving offline inconveniences with tech. Built a sustainable Business Model (BM) by analyzing pain points.",
    proj_gamma_desc: "New IT product naturally connecting tech and daily life. Agilely leading the cycle from MVP planning to initial development with data-driven decisions.",
    insight_title: "Vibe & Insights", insight_desc: "Development philosophy, strategic thoughts, and records of growth.",
    insight_1: "How Flexible Architecture Design Impacts Business Speed",
    insight_2: "The Journey to Finding PMF for Early Services",
    insight_3: "Riding the Rhythm of Code: Survival Secrets of a CSO",
    visual_title: "Visual Archive", visual_desc: "Insights and vibes that couldn't be fully captured in writing are communicated through videos on my YouTube channel.", visual_btn: "Go to Channel",
    footer_h2: "Let's build something.", footer_p: "Looking for a partner to create synergy at the intersection of new tech and business.", footer_rights: "All rights reserved. Vibe Coded."
  },
  ko: {
    nav_about: "소개", nav_projects: "프로젝트", nav_insights: "인사이트", nav_contact: "연락하기",
    hero_badge: "Vibe Coder & CSO",
    hero_hello: "안녕하세요, ", hero_desc1: "입니다.",
    hero_desc2: "기술과 비즈니스의 경계를 허물며 새로운 가치를 만들어내는 CSO입니다.",
    hero_desc3: "{years}년차 개발자로서의 탄탄한 기본기 위에 전략적 인사이트를 더해 비즈니스를 빌딩합니다.",
    github_btn: "GitHub 아카이브", youtube_btn: "유튜브 채널", x_btn: "X (트위터)",
    proj_title: "Strategic Projects", proj_desc: "비즈니스 임팩트를 창출하고 있는 핵심 프로젝트들입니다.",
    proj_alpha_desc: "혁신적인 커뮤니케이션 경험을 제공하는 차세대 플랫폼. 기존의 복잡한 UX를 걷어내고 직관적인 인터페이스와 안정적인 실시간 데이터 처리 아키텍처를 설계했습니다.",
    proj_beta_desc: "오프라인의 불편함을 기술로 해결하는 O2O 기반 라이프케어 매칭 솔루션. 공급자와 수요자의 페인포인트를 분석하여 지속 가능한 비즈니스 모델(BM)을 구축했습니다.",
    proj_gamma_desc: "테크와 일상을 자연스럽게 연결하는 신규 IT 프로덕트. 데이터 기반의 의사결정으로 MVP 기획부터 초기 개발까지의 사이클을 민첩하게 리딩하고 있습니다.",
    insight_title: "Vibe & Insights", insight_desc: "개발 철학, 전략적 고민, 그리고 성장의 기록.",
    insight_1: "유연한 아키텍처 설계가 비즈니스 속도에 미치는 영향",
    insight_2: "초기 서비스의 PMF(Product-Market Fit)를 찾는 여정",
    insight_3: "코드에 리듬을 타다: CSO의 생존 비급",
    visual_title: "Visual Archive", visual_desc: "글로 다 담지 못한 생생한 인사이트와 바이브는 유튜브 채널에서 영상으로 소통합니다.", visual_btn: "채널 바로가기",
    footer_h2: "Let's build something.", footer_p: "새로운 기술과 비즈니스의 교차점에서 시너지를 낼 파트너를 찾습니다.", footer_rights: "모든 권리 보유. Vibe Coded."
  },
  ja: {
    nav_about: "概要", nav_projects: "プロジェクト", nav_insights: "インサイト", nav_contact: "コンタクト",
    hero_badge: "Vibe Coder & CSO",
    hero_hello: "こんにちは、", hero_desc1: "です。",
    hero_desc2: "テクノロジーとビジネスの境界を越え、新たな価値を創造するCSOです。",
    hero_desc3: "{years}年目の開発者としての確かな基礎の上に、戦略的なインサイトを加えてビジネスを構築しています。",
    github_btn: "GitHub アーカイブ", youtube_btn: "YouTube チャンネル", x_btn: "X (Twitter)",
    proj_title: "Strategic Projects", proj_desc: "ビジネスインパクトを生み出しているコアプロジェクトです。",
    proj_alpha_desc: "革新的なコミュニケーション体験を提供する次世代プラットフォーム。複雑なUXを排除し、直感的なインターフェースと安定したリアルタイムデータ処理アーキテクチャを設計しました。",
    proj_beta_desc: "オフラインの不便をテクノロジーで解決するO2Oベースのライフケアマッチングソリューション。ペインポイントを分析し、持続可能なビジネスモデル(BM)を構築しました。",
    proj_gamma_desc: "テクノロジーと日常を自然に結びつける新規ITプロダクト。データに基づく意思決定で、MVP企画から初期開発までのサイクルをアジャイルにリードしています。",
    insight_title: "Vibe & Insights", insight_desc: "開発哲学、戦略的思考、そして成長の記録。",
    insight_1: "柔軟なアーキテクチャ設計がビジネススピードに与える影響",
    insight_2: "初期サービスのPMFを見つける旅",
    insight_3: "コードにリズムを乗せて：CSOの生存の秘訣",
    visual_title: "Visual Archive", visual_desc: "文章だけでは伝えきれない生きたインサイトとバイブスは、YouTubeチャンネルの動画でお届けします。", visual_btn: "チャンネルへ行く",
    footer_h2: "Let's build something.", footer_p: "新しいテクノロジーとビジネスの交差点でシナジーを生み出すパートナーを探しています。", footer_rights: "無断転載を禁じます。Vibe Coded."
  },
  th: {
    nav_about: "เกี่ยวกับ", nav_projects: "โปรเจกต์", nav_insights: "ข้อมูลเชิงลึก", nav_contact: "ติดต่อ",
    hero_badge: "Vibe Coder & CSO",
    hero_hello: "สวัสดี ฉันคือ ", hero_desc1: "",
    hero_desc2: "ทำลายขอบเขตระหว่างเทคโนโลยีและธุรกิจเพื่อสร้างมูลค่าใหม่ในฐานะ CSO",
    hero_desc3: "สร้างธุรกิจด้วยข้อมูลเชิงลึกเชิงกลยุทธ์บนพื้นฐานที่แข็งแกร่งในฐานะนักพัฒนาที่มีประสบการณ์ {years} ปี",
    github_btn: "ที่เก็บถาวร GitHub", youtube_btn: "ช่อง YouTube", x_btn: "X (Twitter)",
    proj_title: "Strategic Projects", proj_desc: "โปรเจกต์หลักที่สร้างผลกระทบทางธุรกิจ",
    proj_alpha_desc: "แพลตฟอร์มยุคหน้าเพื่อประสบการณ์การสื่อสารที่สร้างสรรค์ ออกแบบอินเทอร์เฟซที่ใช้งานง่ายและสถาปัตยกรรมการประมวลผลข้อมูลแบบเรียลไทม์ที่เสถียร",
    proj_beta_desc: "โซลูชันการจับคู่การดูแลชีวิตแบบ O2O ที่แก้ปัญหาออฟไลน์ด้วยเทคโนโลยี สร้างโมเดลธุรกิจ (BM) ที่ยั่งยืนโดยการวิเคราะห์จุดบกพร่อง",
    proj_gamma_desc: "ผลิตภัณฑ์ IT ใหม่ที่เชื่อมต่อเทคโนโลยีและชีวิตประจำวันอย่างเป็นธรรมชาติ นำรอบจากแผน MVP ไปสู่การพัฒนาเบื้องต้นอย่างคล่องตัว",
    insight_title: "Vibe & Insights", insight_desc: "ปรัชญาการพัฒนา ความคิดเชิงกลยุทธ์ และบันทึกการเติบโต",
    insight_1: "การออกแบบสถาปัตยกรรมที่ยืดหยุ่นส่งผลต่อความเร็วของธุรกิจอย่างไร",
    insight_2: "การเดินทางเพื่อค้นหา PMF สำหรับบริการเริ่มต้น",
    insight_3: "ขี่จังหวะของโค้ด: ความลับในการเอาชีวิตรอดของ CSO",
    visual_title: "Visual Archive", visual_desc: "ข้อมูลเชิงลึกและบรรยากาศที่ไม่สามารถถ่ายทอดเป็นลายลักษณ์อักษรได้ทั้งหมด จะถูกสื่อสารผ่านวิดีโอในช่อง YouTube ของฉัน", visual_btn: "ไปที่ช่อง",
    footer_h2: "Let's build something.", footer_p: "กำลังมองหาพันธมิตรเพื่อสร้างการทำงานร่วมกันที่จุดตัดของเทคโนโลยีและธุรกิจใหม่", footer_rights: "สงวนลิขสิทธิ์ Vibe Coded."
  }
};

const App = () => {
  const [lang, setLang] = useState('en');
  const [isLangMenuOpen, setIsLangMenuOpen] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const experienceYears = "5"; 

  // Smooth Scroll 및 실제 IP 기반 국가 감지 적용
  useEffect(() => {
    document.documentElement.classList.add('scroll-smooth');
    
    // 1. 브라우저 언어로 1차 빠른 세팅 (화면 깜빡임 방지)
    const browserLang = navigator.language.slice(0, 2);
    if (['ko', 'ja', 'th'].includes(browserLang)) {
      setLang(browserLang);
    }

    // 2. 실제 접속 IP 기반으로 정확한 국가 감지 API 호출
    const fetchIpLocation = async () => {
      try {
        const response = await fetch('https://get.geojs.io/v1/ip/country.json');
        const data = await response.json();
        
        // IP 국가 코드가 확인되면 해당 언어로 덮어쓰기
        if (data.country === 'KR') setLang('ko');
        else if (data.country === 'JP') setLang('ja');
        else if (data.country === 'TH') setLang('th');
        // 위 국가들이 아니면 초기 브라우저 설정이나 영어(en) 유지
      } catch (error) {
        console.error('IP 위치 확인 실패:', error);
      }
    };

    fetchIpLocation();

    return () => document.documentElement.classList.remove('scroll-smooth');
  }, []);

  const t = translations[lang];

  const projects = [
    { id: 1, title: "Project Alpha", role: "CSO / Lead Developer", description: t.proj_alpha_desc, tags: ["UX/UI Planning", "Architecture", "Strategy"], status: "Live" },
    { id: 2, title: "Project Beta", role: "Service Architect", description: t.proj_beta_desc, tags: ["O2O Platform", "Business Model", "Backend"], status: "Scaling" },
    { id: 3, title: "Project Gamma", role: "Product Owner", description: t.proj_gamma_desc, tags: ["MVP", "Data Analysis", "Agile"], status: "In Progress" }
  ];

  const insights = [
    { id: 1, category: "Tech Vibe", date: "2026. 03. 15", readTime: "5 min read", title: t.insight_1 },
    { id: 2, category: "Strategy Note", date: "2026. 02. 28", readTime: "7 min read", title: t.insight_2 },
    { id: 3, category: "Vibe Coder", date: "2026. 01. 10", readTime: "4 min read", title: t.insight_3 }
  ];

  const handleNavClick = () => {
    setIsMobileMenuOpen(false);
  };

  return (
    <div className="min-h-screen bg-zinc-950 text-zinc-50 font-sans selection:bg-indigo-500/30 pb-10">
      
      {/* Navigation */}
      <nav className="fixed top-0 w-full z-50 bg-zinc-950/80 backdrop-blur-md border-b border-zinc-800">
        <div className="max-w-6xl mx-auto px-6 h-20 flex items-center justify-between">
          <a href="#about" className="text-xl font-bold tracking-tighter flex items-center gap-2 hover:opacity-80 transition-opacity">
            <span className="text-indigo-400"><Terminal size={24} /></span>
            VivLeoN<span className="text-zinc-500">.</span>
          </a>
          
          <div className="flex items-center gap-4 md:gap-8">
            {/* Desktop Links */}
            <div className="hidden md:flex gap-8 text-sm font-medium text-zinc-400">
              <a href="#about" className="hover:text-zinc-50 transition-colors">{t.nav_about}</a>
              <a href="#projects" className="hover:text-zinc-50 transition-colors">{t.nav_projects}</a>
              <a href="#insights" className="hover:text-zinc-50 transition-colors">{t.nav_insights}</a>
            </div>

            {/* Language Switcher (Click Toggle 방식) */}
            <div className="relative">
              <button 
                onClick={() => setIsLangMenuOpen(!isLangMenuOpen)}
                className={`flex items-center gap-1.5 text-sm font-medium px-3 py-1.5 rounded-md border transition-colors ${
                  isLangMenuOpen ? 'bg-zinc-800 border-zinc-700 text-zinc-50' : 'bg-zinc-900/50 border-zinc-800 text-zinc-400 hover:text-zinc-50 hover:bg-zinc-800'
                }`}
              >
                <Globe size={14} /> <span className="hidden sm:inline">{lang.toUpperCase()}</span>
              </button>
              
              {/* 바깥 영역 클릭 시 메뉴 닫기용 투명 백드롭 */}
              {isLangMenuOpen && (
                <div 
                  className="fixed inset-0 z-40" 
                  onClick={() => setIsLangMenuOpen(false)}
                />
              )}

              {/* 드롭다운 메뉴 */}
              {isLangMenuOpen && (
                <div className="absolute right-0 top-full mt-2 w-32 bg-zinc-900 border border-zinc-700 rounded-lg overflow-hidden shadow-2xl flex flex-col z-50 animate-in fade-in zoom-in-95 duration-150">
                  {[{code: 'en', label: 'English'}, {code: 'ko', label: '한국어'}, {code: 'ja', label: '日本語'}, {code: 'th', label: 'ภาษาไทย'}].map(l => (
                    <button 
                      key={l.code} 
                      onClick={() => { setLang(l.code); setIsLangMenuOpen(false); }} 
                      className={`px-4 py-3 text-sm text-left hover:bg-zinc-800 transition-colors ${lang === l.code ? 'text-indigo-400 font-bold bg-zinc-800/50' : 'text-zinc-300'}`}
                    >
                      {l.label}
                    </button>
                  ))}
                </div>
              )}
            </div>

            <a href="#contact" className="hidden lg:inline-flex items-center justify-center px-5 py-2 text-sm font-medium bg-zinc-100 text-zinc-900 rounded-full hover:bg-white hover:scale-105 transition-all duration-300">
              {t.nav_contact}
            </a>

            {/* Mobile Menu Toggle */}
            <button 
              className="md:hidden text-zinc-400 hover:text-zinc-50 transition-colors"
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            >
              {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
            </button>
          </div>
        </div>

        {/* Mobile Navigation Dropdown */}
        {isMobileMenuOpen && (
          <div className="md:hidden absolute top-20 left-0 w-full bg-zinc-950 border-b border-zinc-800 px-6 py-4 flex flex-col gap-4 shadow-xl animate-in slide-in-from-top-2">
            <a href="#about" onClick={handleNavClick} className="text-zinc-400 hover:text-zinc-50 py-2 font-medium">{t.nav_about}</a>
            <a href="#projects" onClick={handleNavClick} className="text-zinc-400 hover:text-zinc-50 py-2 font-medium">{t.nav_projects}</a>
            <a href="#insights" onClick={handleNavClick} className="text-zinc-400 hover:text-zinc-50 py-2 font-medium">{t.nav_insights}</a>
            <a href="#contact" onClick={handleNavClick} className="text-indigo-400 hover:text-indigo-300 py-2 font-medium">{t.nav_contact}</a>
          </div>
        )}
      </nav>

      <main className="pt-32 pb-20 px-6 max-w-6xl mx-auto space-y-32">
        
        {/* Hero Section */}
        <section id="about" className="space-y-8 animate-in fade-in slide-in-from-bottom-8 duration-1000">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-indigo-500/10 text-indigo-400 text-sm font-medium border border-indigo-500/20">
            <Zap size={14} />
            <span>{t.hero_badge}</span>
          </div>
          
          <h1 className="text-5xl md:text-7xl font-bold tracking-tight leading-[1.1]">
            Code the <span className="text-transparent bg-clip-text bg-gradient-to-r from-indigo-400 to-purple-400">Vibe</span>,<br />
            Design the <span className="text-transparent bg-clip-text bg-gradient-to-r from-zinc-100 to-zinc-500">Strategy.</span>
          </h1>
          
          <p className="text-lg md:text-xl text-zinc-400 max-w-2xl leading-relaxed">
            {t.hero_hello}<strong className="text-zinc-100 font-medium">VivLeoN</strong>{t.hero_desc1}<br />
            {t.hero_desc2}<br />
            {t.hero_desc3.replace('{years}', experienceYears)}
          </p>

          <div className="flex flex-wrap gap-4 pt-4">
            <a href="https://github.com/vivleon?page=2&tab=repositories" target="_blank" rel="noreferrer" className="flex items-center gap-2 px-5 py-3 rounded-xl bg-zinc-900 border border-zinc-800 hover:border-zinc-700 hover:bg-zinc-800/50 transition-all text-sm font-medium">
              <Github size={18} />
              {t.github_btn}
            </a>
            <a href="https://www.youtube.com/@vivleon.original" target="_blank" rel="noreferrer" className="flex items-center gap-2 px-5 py-3 rounded-xl bg-zinc-900 border border-zinc-800 hover:border-zinc-700 hover:bg-zinc-800/50 transition-all text-sm font-medium text-red-400 hover:text-red-300">
              <Youtube size={18} />
              {t.youtube_btn}
            </a>
            <a href="https://x.com/VivLeoNofficial" target="_blank" rel="noreferrer" className="flex items-center gap-2 px-5 py-3 rounded-xl bg-zinc-900 border border-zinc-800 hover:border-zinc-700 hover:bg-zinc-800/50 transition-all text-sm font-medium text-zinc-300 hover:text-white">
              <XIcon size={16} />
              {t.x_btn}
            </a>
          </div>
        </section>

        {/* Projects Section */}
        <section id="projects" className="space-y-12 scroll-mt-32">
          <div className="space-y-4">
            <h2 className="text-3xl font-bold flex items-center gap-3">
              <Briefcase className="text-indigo-400" />
              {t.proj_title}
            </h2>
            <p className="text-zinc-400">{t.proj_desc}</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {projects.map((project) => (
              <div key={project.id} className="group relative p-6 rounded-2xl bg-zinc-900/50 border border-zinc-800 hover:border-indigo-500/50 hover:bg-zinc-900 transition-all duration-300 flex flex-col justify-between overflow-hidden">
                <div className="absolute top-0 right-0 p-6 opacity-0 group-hover:opacity-100 transition-opacity translate-x-2 -translate-y-2 group-hover:translate-x-0 group-hover:translate-y-0 text-indigo-400">
                  <ArrowUpRight size={24} />
                </div>
                
                <div className="space-y-4">
                  <div className="flex justify-between items-start">
                    <span className="text-xs font-mono px-2 py-1 bg-zinc-800 rounded text-zinc-300">
                      {project.status}
                    </span>
                  </div>
                  <div>
                    <h3 className="text-xl font-bold mb-1 group-hover:text-indigo-300 transition-colors">{project.title}</h3>
                    <p className="text-sm font-medium text-indigo-400/80 mb-4">{project.role}</p>
                    <p className="text-sm text-zinc-400 leading-relaxed">
                      {project.description}
                    </p>
                  </div>
                </div>

                <div className="pt-6 flex flex-wrap gap-2">
                  {project.tags.map((tag, index) => (
                    <span key={index} className="text-xs px-2.5 py-1 rounded-full bg-zinc-800/80 text-zinc-300 border border-zinc-700/50">
                      {tag}
                    </span>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </section>

        {/* Insights Section */}
        <section id="insights" className="space-y-12 scroll-mt-32">
          <div className="space-y-4">
            <h2 className="text-3xl font-bold flex items-center gap-3">
              <BookOpen className="text-purple-400" />
              {t.insight_title}
            </h2>
            <p className="text-zinc-400">{t.insight_desc}</p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
            <div className="space-y-4">
              {insights.map((insight) => (
                <article key={insight.id} className="group flex flex-col sm:flex-row sm:items-center justify-between p-5 rounded-2xl bg-zinc-900/30 border border-zinc-800/50 hover:border-zinc-700 hover:bg-zinc-800/50 transition-all cursor-pointer">
                  <div className="space-y-2 mb-4 sm:mb-0">
                    <div className="flex items-center gap-3">
                      <span className="text-xs font-semibold text-purple-400 tracking-wider uppercase">
                        {insight.category}
                      </span>
                      <span className="text-xs text-zinc-500">{insight.date}</span>
                    </div>
                    <h3 className="text-lg font-medium text-zinc-100 group-hover:text-white transition-colors">
                      {insight.title}
                    </h3>
                  </div>
                  <div className="flex items-center justify-between sm:justify-end w-full sm:w-auto gap-4 text-zinc-500 group-hover:text-zinc-300 transition-colors">
                    <span className="text-xs whitespace-nowrap">{insight.readTime}</span>
                    <ChevronRight size={18} className="transform group-hover:translate-x-1 transition-transform" />
                  </div>
                </article>
              ))}
            </div>
            
            {/* Visual Archive / Featured */}
            <div className="relative rounded-2xl border border-zinc-800 bg-zinc-900 p-8 flex flex-col justify-center items-center text-center overflow-hidden group">
              <div className="absolute inset-0 bg-gradient-to-br from-indigo-500/10 to-purple-500/10 opacity-50 group-hover:opacity-100 transition-opacity"></div>
              <Youtube size={48} className="text-zinc-700 mb-6 group-hover:text-red-500 transition-colors duration-500" />
              <h3 className="text-xl font-bold mb-2 relative z-10">{t.visual_title}</h3>
              <p className="text-sm text-zinc-400 max-w-xs relative z-10 mb-6">
                {t.visual_desc}
              </p>
              <a href="https://www.youtube.com/@vivleon.original" target="_blank" rel="noreferrer" className="relative z-10 inline-flex items-center gap-2 text-sm font-medium text-white bg-zinc-800 hover:bg-zinc-700 px-4 py-2 rounded-full transition-colors">
                {t.visual_btn} <ArrowUpRight size={14} />
              </a>
            </div>
          </div>
        </section>

      </main>

      {/* Footer / Contact */}
      <footer id="contact" className="border-t border-zinc-900 bg-zinc-950/50 mt-20">
        <div className="max-w-6xl mx-auto px-6 py-16 flex flex-col md:flex-row items-center justify-between gap-8">
          <div className="text-center md:text-left space-y-2">
            <h2 className="text-2xl font-bold">{t.footer_h2}</h2>
            <p className="text-zinc-400 text-sm">{t.footer_p}</p>
          </div>
          
          <div className="flex items-center gap-6">
            <a href="mailto:hello@vivleon.dev" className="text-zinc-400 hover:text-white transition-colors flex items-center gap-2 text-sm font-medium">
              <Mail size={18} />
              Contact
            </a>
            <a href="https://github.com/vivleon" target="_blank" rel="noreferrer" className="text-zinc-400 hover:text-white transition-colors">
              <Github size={20} />
            </a>
            <a href="https://www.youtube.com/@vivleon.original" target="_blank" rel="noreferrer" className="text-zinc-400 hover:text-white transition-colors">
              <Youtube size={20} />
            </a>
            <a href="https://x.com/VivLeoNofficial" target="_blank" rel="noreferrer" className="text-zinc-400 hover:text-white transition-colors">
              <XIcon size={18} />
            </a>
          </div>
        </div>
        <div className="text-center pb-8 text-xs text-zinc-600">
          © {new Date().getFullYear()} VivLeoN. {t.footer_rights}
        </div>
      </footer>
    </div>
  );
};

export default App;
